import axios from "../request";

//角色列表
export function getRole(data) {
  return axios.request({
    url: "api/Role",
    method: "get",
    params: data,
  });
}
//角色选择列表
export function getRoleSel(data) {
    return axios.request({
      url: "api/Role/GetSelAsync",
      method: "get",
      params: data,
    });
  }
//新增角色
export function addRole(data) {
  return axios.request({
    url: "api/Role",
    method: "post",
    data: data
  });
}

//删除角色
export function delRole(id) {
  return axios.request({
    url: "api/Role/"+id,
    method: "delete"
  });
}

//设置角色权限
export function setRolePower(id, data) {
  return axios.request({
    url: "api/Role/SetPower/"+id,
    method: "put",
    data: data
  });
}
